import '../../styles/Globales.scss';


import React, { Component } from 'react'
import { Typography } from '@material-ui/core';
import * as ValidationUtils from '../../utils/ValidationUtils';
import { DoneOutlined } from '@material-ui/icons';

export default class ListaProductoResumenComponent extends Component {
    render() {
        let numeroCuenta;
        if (this.props.producto.numeroCuenta) {
            numeroCuenta = ValidationUtils.formatNumeroCuenta(this.props.producto.numeroCuenta);
        }
        return (
            <div className="btnResumen">
                <div className="tituloBtnResumen">
                    <div>
                        <Typography>{this.props.producto.nombreProducto}</Typography>
                    </div>
                    <div className="btnResumenDerecha">
                        <span>{numeroCuenta}</span>
                        <DoneOutlined></DoneOutlined>
                    </div>
                </div>
            </div>
        )
    }
}
